/**
 * Fallback for an env.js that predates `security.passwordPolicy`. Mirrors the server-side
 * defaults, so a form that falls back here still asks for what the server enforces.
 */
export const DEFAULT_PASSWORD_POLICY = {
    minLength: 8,
    maxLength: 72,
    requireDigit: false,
    requireLowerCase: false,
    requireUpperCase: false,
    requireSpecialCharacter: false,
};
const defaults = {
    path: './',
    locale: 'de',
    version: '0.0.0',
    app: {
        name: 'Paloma',
        title: 'Paloma',
    },
    security: {
        anonymousAccessEnabled: false,
    },
    user: {
        authenticated: false,
        username: 'anonymous',
        permissions: [],
    },
    translations: {
        baseUrl: '/messages',
        locales: ['de'],
    },
    files: {
        baseUrl: '/files'
    },
    // kept as a default for applications whose env.js does not provide the
    // key; set it to an empty value there to switch the notice off
    maintenance: {
        url: 'https://status.astina.ch/maintenance',
    },
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    applications: [],
};
// @ts-ignore
const env = { ...defaults, ...window._ENV };
export default env;
